import { responseError } from '@/utils/errors';
import { assignIfExists, mapResults, assignProps } from '@/utils/resultsHelper';
import { states, saveStates } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import { configurationsResult, findConfiguration, findConfigurations } from './state';

const applyConfigurations = withDraft((draft, action) => {
  const item = findConfigurations(draft, action);
  item.results = mapResults([], action, configurationsResult);
});

const fetchConfiguration = withDraft((draft, action) => {
  const item = findConfiguration(draft, action);
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.configurations[action.category].results.push({
      code: action.code,
      value: {},
      readStatus: states.PENDING,
      readErrors: [],
      ...saveStates,
    });
  }
});

const showConfigurationSuccess = withDraft((draft, action) => {
  const item = findConfiguration(draft, action);
  if (item) {
    assignProps(item, {
      ...action.result,
      readStatus: states.SUCCESS,
      readErrors: [],
      ...saveStates,
    });
  } else {
    draft.configurations[action.category].results.push({
      ...action.result,
      readStatus: states.SUCCESS,
      readErrors: [],
      ...saveStates,
    });
  }
});

const showConfigurationError = withDraft((draft, action) => {
  const item = findConfiguration(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const updateConfigurationProperties = withDraft((draft, action) => {
  const item = findConfiguration(draft, action);
  assignIfExists(item, action.properties);
});

const startSavingConfiguration = withDraft((draft, action) => {
  const item = findConfiguration(draft, action);
  item.saveStatus = states.PENDING;
});

const updateConfigurationError = withDraft((draft, action) => {
  const item = findConfiguration(draft, action);
  assignIfExists(item, {
    saveStatus: states.ERROR,
    saveErrors: [responseError(action)],
  });
});

const updateConfigurationSuccess = withDraft((draft, action) => {
  const item = findConfiguration(draft, action);
  draft.activeApprovalOpen = false;
  assignIfExists(item, {
    ...action.result,
    saveStatus: states.SUCCESS,
    saveErrors: [],
  });
});

const hideAutoApprovalConfiguration = withDraft((draft) => { draft.activeApprovalOpen = false; });

const showAutoApprovalConfiguration = withDraft((draft) => { draft.activeApprovalOpen = true; });

export default {
  [actions.APPLY_CONFIGURATIONS]: applyConfigurations,
  [actions.FETCH_CONFIGURATION]: fetchConfiguration,
  [actions.HIDE_AUTO_APPROVAL_CONFIGURATION]: hideAutoApprovalConfiguration,
  [actions.SHOW_AUTO_APPROVAL_CONFIGURATION]: showAutoApprovalConfiguration,
  [actions.SHOW_CONFIGURATION_SUCCESS]: showConfigurationSuccess,
  [actions.SHOW_CONFIGURATION_ERROR]: showConfigurationError,
  [actions.TOGGLE_AUTO_APPROVAL_CONFIGURATION]: startSavingConfiguration,
  [actions.UPDATE_CONFIGURATION_ERROR]: updateConfigurationError,
  [actions.UPDATE_CONFIGURATION_PROPERTIES]: updateConfigurationProperties,
  [actions.UPDATE_CONFIGURATION_SUCCESS]: updateConfigurationSuccess,
  [actions.UPDATE_DEFAULT_ROLE_CONFIGURATION]: startSavingConfiguration,
};
